module.exports = __webpack_public_path__ + "img/ico-checkbox-checked-grey.e3bc98d7.svg";